import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import { ROUTES } from "@/routes/constants";

import App from './App';
import './index.css';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <BrowserRouter basename={ROUTES.BASE_URL}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
